<div class="tournament-cards">
  @for (tournament of tournaments(); track $index) {
    <app-tournament-card [tournament]="tournament" (updateEvent)="getTournaments()"></app-tournament-card>
  }
</div>
@if(!tournaments().length) {
  <span>{{ 'no-item.tournaments' | translate }}</span>
}